import {onboardingGoingLiveBeforeServicing} from '@client/remote-config';
import {NavigationGuardNext, Route} from 'vue-router';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const onboardingLiveBeforeServicing = async () => {
  const onboardingBeforeServicing = await onboardingGoingLiveBeforeServicing();

  return onboardingBeforeServicing;
};

export enum RiskToleranceRouteNames {
  RiskTolerancePage = 'RiskTolerancePage',
}

export default [
  {
    path: '/clientdashboard/risktolerance',
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import('@client/layouts/authenticated/Index.vue'),
    beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
      if (await onboardingLiveBeforeServicing()) {
        window.location.href =
          process.env.VUE_APP_ENV === 'prod'
            ? 'https://advisedservices.individuals.principal.com'
            : 'https://advisedservices.individuals.staging.principal.com';
      }

      // eslint-disable-next-line callback-return
      next();
    },
    meta: {
      useLayouts: true,
    },
    children: [
      {
        path: '',
        name: RiskToleranceRouteNames.RiskTolerancePage,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        component: () => import('@client/pages/riskTolerance/RiskTolerancePage.vue'),
        meta: {
          useLayouts: true,
        },
      },
    ],
  },
];
